import React from "react";
import PropTypes from "prop-types";
import { IconForm } from "@domestika-dev/prudencio/dist/atoms/Icon";
import { Camera } from "@domestika-dev/prudencio/dist/atoms/Icons";
import { Flex } from "@domestika-dev/prudencio/dist/atoms/Layout";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography";

export const EmptySectionPlaceholder = ({ message, children }) => (
  <Flex
    border="2px solid"
    borderColor="langsat"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    padding={[4, 6, 6]}
  >
    <Flex borderRadius="50%" border="2px solid" borderColor="langsat" padding={4}>
      <IconForm size="medium">
        <Camera />
      </IconForm>
    </Flex>
    <Text size="small" fontWeight="medium" textAlign="center" marginTop={[3, 4, 4]}>
      {message}
    </Text>
    {children}
  </Flex>
);

EmptySectionPlaceholder.propTypes = {
  message: PropTypes.string.isRequired,
  children: PropTypes.node,
};

EmptySectionPlaceholder.defaultProps = {
  children: null,
};

export default EmptySectionPlaceholder;
